export const decodeHtml = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export const findWord = (input: string, word: string) => {
  // Create a regular expression pattern dynamically using the input word
  const pattern = new RegExp(`\\b${word}\\b`, 'gi');

  // Use the match() method with the pattern to find matches in the input string
  const matches = input.match(pattern);

  return matches;
};

export const findWords = (input: string, words: string[]) => {
  // Create a regular expression pattern dynamically using the input word
  return words.every(word => Boolean(findWord(input, word)));
};
